import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";
import { clx } from "../../../utils/Helpers";

import { uiTokens } from "../../../utils/uiTokens";
import "./_UIChip.scss";

const pillShapeSx = {
  height: uiTokens.space[24],
  borderRadius: uiTokens.radius.full,
  fontSize: uiTokens.typography.label.sm.fontSize,
  fontWeight: uiTokens.typography.label.sm.fontWeight,
  lineHeight: uiTokens.typography.label.sm.lineHeight,
  "& .MuiChip-label": { px: 1 },
};

const UIChip = ({
  shape = "default",
  size = "small",
  color = "primary",
  appearance = "light",
  className = "",
  sx,
  ...props
}) => {
  const mergedSx =
    shape === "pill"
      ? Array.isArray(sx)
        ? [pillShapeSx, ...sx]
        : [pillShapeSx, sx].filter(Boolean)
      : sx;

  return (
    <Chip
      size={size}
      // "muted" / "primarySubtle" are ours only (styled in _UIChip.scss) — MUI has no palette entry for them.
      color={
        color === "muted"
          ? "default"
          : color === "primarySubtle"
            ? "primary"
            : color
      }
      className={clx(
        "ui-chip",
        shape === "pill" && "ui-chip--pill",
        `ui-chip--${color}`,
        `ui-chip--${appearance}`,
        className
      )}
      sx={mergedSx}
      {...props}
    />
  );
};

UIChip.propTypes = {
  shape: PropTypes.oneOf(["default", "pill"]),
  size: PropTypes.oneOf(["small", "medium"]),
  color: PropTypes.oneOf([
    "default",
    "primary",
    "primarySubtle",
    "secondary",
    "success",
    "warning",
    "error",
    "info",
    "muted",
  ]),
  appearance: PropTypes.oneOf(["light", "solid", "ghost"]),
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
};

UIChip.defaultProps = {
  shape: "default",
  size: "small",
  color: "primary",
  appearance: "light",
  className: "",
  sx: undefined,
};

export default UIChip;
